<ng-http-loader [debounceDelay]="200" [extraDuration]="0" [backdrop]="true" [opacity]="1"
  [entryComponent]="ProgressBarComponent"></ng-http-loader>
<side-nav>
  <top-nav></top-nav>
  <section class="app-body">
    <router-outlet></router-outlet>
  </section>
</side-nav>